import React from 'react';
import { Page, Font,  Text, Document, StyleSheet, Image, Link } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';

import Header from "./Header";
import Footer from "./Footer";
import About from "./About";

// Create styles
const styles = StyleSheet.create({
    page: {
        display: 'flex',
        margin: 0,
        fontfamily: 'TTNorms',
    },
    image: {
        marginTop: 12,
        marginBottom: 0,
        marginLeft: 20,
        width:555,
    },
    textlist: {
        color: '#666666',
        margin: '2px 20px 0 30px',
        fontSize: 10,
        fontFamily: 'TTNorms',
        width:555,
    },
    link: {
        color: 'blue',
    }
});

Font.register( {
    family: 'IvyJournal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    src: `https://governwith.s3.ap-southeast-2.amazonaws.com/fonts/IvyJournal-Regular.ttf`,
});

Font.register( {
    family: 'IvyJournal',
    fontStyle: 'bold',
    fontWeight: 'bold',
    src: `https://governwith.s3.ap-southeast-2.amazonaws.com/fonts/IvyJournal-SemiBold.ttf`,
});

Font.register( {
    family: 'TTNorms',
    fontStyle: 'normal',
    fontWeight: 'normal',
    src: `https://governwith.s3.ap-southeast-2.amazonaws.com/fonts/tt_norms_regular.ttf`,
});

Font.register( {
    family: 'TTNorms',
    fontStyle: 'bold',
    fontWeight: 'bold',
    src: `https://governwith.s3.ap-southeast-2.amazonaws.com/fonts/tt_norms_bold.ttf`,
});

const PageContent = styled.View`
  margin: 0 0 0 0;
  position: 'relative';
`;

const Heading = styled.Text`
  margin: 16px 20px 0 20px;
  font-size: 22px;
  font-family: 'IvyJournal';
  font-weight: bold;
  color: white;
`;

const Heading2 = styled.Text`
  margin: 11px 20px 4px 20px;
  font-size: 16px;
  font-family: 'IvyJournal';
  font-weight: bold;
  color: white;
`;


const ModuleContentTop = styled.Text`
  color: #333333;
  margin: 20px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

const ModuleContentTop3 = styled.Text`
  color: #333333;
  margin: 58px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

const ModuleContent = styled.Text`
  color: #333333;
  margin: 8px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

const ModuleContentBold = styled.Text`
  color: #000000;
  margin: 8px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

const ModuleTitle = styled.Text`
  color: #000000;
  margin: 12px 20px 0 20px;
  font-size: 14px;
  font-family: 'TTNorms';
`;

const ModuleTitleTop = styled.Text`
  color: #000000;
  margin: 58px 20px 0 20px;
  font-size: 14px;
  font-family: 'TTNorms';
`;

const ModuleQuestion = styled.Text`
  color: #666666;
  margin: 2px 20px 0 30px;
  font-size: 10px;
  font-family: 'TTNorms';
`;
// const ModuleQuestion2 = styled.Text`
//   color: #666666;
//   margin: 2px 20px 0 37px;
//   font-size: 10px;
//   font-family: 'PTSans';
// `;
// tables
const Table = styled.View`
  display: table;
  width:555px;
  margin: 20px 20px 20px 20px
  border-style: solid;
  border-width: 1;
  border-bottom: 0;
  border-right: 0;
`;
const TableRow = styled.View`
  margin: auto; 
  flexDirection: row;
`;
const TableCell10 = styled.View`
  width: 10%;
  border-style: solid;
  border-width: 1;
  padding: 4px;
  font-size: 10px;
  font-family: 'TTNorms';
  border-style: solid;
  border-width: 1;
  border-top: 0;
  border-left: 0;
  display:flex;
  flex-direction:row;
`;
const TableCell12 = styled.View`
  width: 12%;
  border-style: solid;
  border-width: 1;
  padding: 4px;
  border-style: solid;
  border-width: 1;
  border-top: 0;
  border-left: 0;
  display:flex;
  flex-direction:row;
`;
const TableCell15 = styled.View`
  width: 15%;
  border-style: solid;
  border-width: 1;
  padding: 4px;
  border-style: solid;
  border-width: 1;
  border-top: 0;
  border-left: 0;
  display:flex;
  flex-direction:row;
`;
const TableCell16 = styled.View`
  width: 16%;
  border-style: solid; 
  border-width: 1;
  padding: 4px;
  border-style: solid;
  border-width: 1;
  border-top: 0;
  border-left: 0;
  display:flex;
  flex-direction:row;
`;

const TableCell19 = styled.View`
  width: 19%;
  border-style: solid;
  border-width: 1;
  padding: 4px;
  border-style: solid;
  border-width: 1;
  border-top: 0;
  border-left: 0;
  display:flex;
  flex-direction:row;
`;

const TableHeading = styled.Text`
  color: #000000;
  font-size: 10px;  
  font-family: 'TTNorms';
`;
const TableData = styled.Text`
  color: #333333;
  font-size: 10px;
  font-family: 'TTNorms';
`
const TableDataWhite = styled.Text`
  color: #ffffff;
  font-size: 10px;
  font-family: 'TTNorms';
`

// Create Document Component
class MyDocument extends React.Component{
    render(){
        console.log(this.props);
        const tdate = new Date();
        const sdate = new Date();
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        const ap = ProcessResults(this.props.rdata.results, tdate);

        console.log(tdate.toString());

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    <Header/>
                    <PageContent>
                        <Heading>
                            Governance Evaluation Results
                        </Heading>
                        <Heading2>
                            Risk Management and Compliance
                        </Heading2>
                        <ModuleContentTop>
                            Risk is defined as the effect of uncertainty on objectives (ISO 3100:2009). Risk
                            management creates and protects the values of a organisation through processes,
                            structures and systems that help the organisation achieve its objectives and improve its
                            performance.
                            Compliance ensures that the requirements of laws, regulations, industry codes and
                            standards are met.
                        </ModuleContentTop>
                        <ModuleContent>
                            A compliance program is an important element in the governance of an organisation and should:
                        </ModuleContent>
                        <Text style={styles.textlist}>&bull; prevent, identify and respond to breaches of laws, regulations, codes or standards that occur in the organisation.</Text>
                        <Text style={styles.textlist}>&bull; promote a culture of compliance within the organisation.</Text>
                        <Text style={styles.textlist}>&bull; assist the organisation to be a good corporate citizen.</Text>
                        <ModuleContentBold>
                            Your survey responses versus our 2020 Benchmark data:
                        </ModuleContentBold>
                        <ModuleTitle>
                            Risk Appetite and Tolerance
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Has the organisation formulated a statement of its risk appetite and risk
                            tolerances, which aims to align its risk-taking{"\n"}capability with its strategic objectives?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s0q1_${this.props.rdata.results.s0q1}.png`}
                            style={styles.image}
                        />
                        <ModuleTitle>
                            Risk Management
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Have the key risks (including consideration of all major risk categories, such as
                            strategic, financial, environmental,{"\n"}
                            clinical/service, project and human resources’ related risks) that will have the
                            greatest impact on achieving the organisation’s{"\n"}objectives been identified and reported?{"\n"}
                        </ModuleQuestion>
                        <ModuleQuestion>
                            &bull; Does the board receive a regular update on the action plans that are used to
                            manage all major risks affecting the organisation?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s0q2_${this.props.rdata.results.s0q2}.png`}
                            style={styles.image}
                        />
                        <ModuleTitle>
                            Risk Systems
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Does the board have a risk management framework that meets the board’s current
                            requirements for risk management?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s0q3_${this.props.rdata.results.s0q3}.png`}
                            style={styles.image}
                        />
                        <ModuleTitle>
                            Compliance
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Does the board receive a comprehensive and relevant compliance report covering
                            all relevant legislation, standards and funding{"\n"}requirements?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s0q4_${this.props.rdata.results.s0q4}.png`}
                            style={styles.image}
                        />
                    </PageContent>
                    <Footer form={this.props.rdata.form}/>
                </Page>
                <Page size="A4" style={styles.page}>
                    <Header/>
                    <PageContent>
                        <Heading>
                            Governance Evaluation Results
                        </Heading>
                        <Heading2>
                            Stakeholder Engagement
                        </Heading2>
                        <ModuleContentTop>
                            The critical nexus between the decision-making and accountability functions comes from
                            informed, meaningful and effective engagement between stakeholders and the board.
                            Stakeholders are represented by many groups such as; community, customers, staff,
                            funders, government, partners and others.
                        </ModuleContentTop>
                        <ModuleContent>
                            Effective engagement with stakeholder groups is the responsibility of management and the
                            board, particularly the chair. A board needs to be aware of the stakeholders who are
                            affected by, or affect their organisation and need to build long-term relationships of
                            constructive engagement. Engagement includes but is not limited to communication with
                            stakeholders.
                        </ModuleContent>
                        <ModuleContentBold>
                            Your survey responses versus our 2020 Benchmark data:
                        </ModuleContentBold>
                        <ModuleTitle>
                            Stakeholder Communication
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Does the board actively influence and communicate with a wide range of
                            stakeholders on key initiatives and plans?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s1q1_${this.props.rdata.results.s1q1}.png`}
                            style={styles.image}
                        />
                        <ModuleTitle>
                            Stakeholder Influence
                        </ModuleTitle>
                        <ModuleQuestion>
                            &bull; Does information acquired through stakeholder engagement inform strategic
                            planning and review processes?
                        </ModuleQuestion>
                        <Image
                            src={`https://gep-pardot-assets.s3-ap-southeast-2.amazonaws.com/questionnaire/images/2020_pdf_images/s1q2_${this.props.rdata.results.s1q2}.png`}
                            style={styles.image}
                        />
                    </PageContent>
                    <Footer form={this.props.rdata.form} />
                </Page>
                <Page size="A4" style={styles.page}>
                    <Header/>
                    <PageContent>
                        <Heading>
                            Plan to act!
                        </Heading>
                        <ModuleContentTop3>
                            Completing your questionnaire is only the first step in our evaluation process. Once you have reviewed your results the next step is to plan to act.
                        </ModuleContentTop3>
                        <ModuleContent>
                            We do so by developing an interactive action plan containing links to our online support resources as well as providing links to our partners expert resources, services and education programs for ensuring ongoing development.
                        </ModuleContent>
                        <ModuleContent>
                            The action plan can be continually reviewed and updated through our online platform, sending timely reminders for completion. Your action plan can then be downloaded for inclusion within board documents for review and development status.
                        </ModuleContent>
                        <ModuleContent>
                            For your action plan below, we've taken your responses and utilised these to demonstrate your progress through an example of what our action plans can cover.
                        </ModuleContent>
                        <ModuleTitle>
                            Governance evaluation completed in {monthNames[sdate.getMonth()]} {sdate.getFullYear()}
                        </ModuleTitle>
                        <ModuleContent>
                            Individual action plan example prepared for {this.props.rdata.form.firstname} {this.props.rdata.form.lastname}
                        </ModuleContent>
                        <ModuleTitle>Risk Management And Compliance</ModuleTitle>
                        <Table>
                            <TableRow>
                                <TableCell15>
                                    <TableHeading>Title</TableHeading>
                                </TableCell15>
                                <TableCell19>
                                    <TableHeading>Action</TableHeading>
                                </TableCell19>
                                <TableCell10>
                                    <TableHeading>Due Date</TableHeading>
                                </TableCell10>
                                <TableCell12>
                                    <TableHeading>Responsible</TableHeading>
                                </TableCell12>
                                <TableCell16>
                                    <TableHeading>Resources</TableHeading>
                                </TableCell16>
                                <TableCell12>
                                    <TableHeading>Status</TableHeading>
                                </TableCell12>
                                <TableCell16>
                                    <TableHeading>Comments</TableHeading>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Risk Appetite{"\n"}and Tolerance</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>Review and update Board’s risk appetite statement when new strategic plan completed.</TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s0q1.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData><Text>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</Text></TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Pdf: <Link style={styles.link} src="https://bit.ly/386djsy">{"\n"}Risk Appetite Fact Sheet</Link>{"\n"}{"\n"}Video: <Link style={styles.link} src="https://bit.ly/2NS5qjO">{"\n"}Risk Appetite and Tolerance</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s0q1.color}`}}>
                                    <TableDataWhite>{ap.s0q1.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Risk{"\n"}Management</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>Presentation to Board of top{"\n"}organisational risks with key indicators for ongoing{"\n"}measurement, review and benchmarking.</TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s0q2.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Video: <Link style={styles.link} src="https://bit.ly/3bbpjLp">{"\n"}Risk{"\n"}Management for Boards</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s0q2.color}`}}>
                                    <TableDataWhite>{ap.s0q2.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Risk Systems</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>Review and revise present risk management framework for presentation to Board.</TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s0q3.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Pdf: <Link style={styles.link} src="https://bit.ly/384NYiz">{"\n"}Risk{"\n"}Management Framework and Reporting Structure</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s0q3.color}`}}>
                                    <TableDataWhite>{ap.s0q3.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Compliance</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>
                                        Annual Compliance Status Board Report:{"\n"}{"\n"}
                                        &bull; Download annual Board compliance{"\n"}report template from GovernWith Portal for Board report at next Board meeting
                                    </TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s0q4.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Pdf: <Link style={styles.link} src="https://bit.ly/2MQfA3S">{"\n"}Compliance checklist</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s0q4.color}`}}>
                                    <TableDataWhite>{ap.s0q4.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                        </Table>
                    </PageContent>
                    <Footer form={this.props.rdata.form} />
                </Page>
                <Page size="A4" style={styles.page}>
                    <Header/>
                    <PageContent>
                        <Heading>
                            Plan to act!
                        </Heading>
                        <ModuleTitleTop>Stakeholder Engagement</ModuleTitleTop>
                        <Table>
                            <TableRow>
                                <TableCell15>
                                    <TableHeading>Title</TableHeading>
                                </TableCell15>
                                <TableCell19>
                                    <TableHeading>Action</TableHeading>
                                </TableCell19>
                                <TableCell10>
                                    <TableHeading>Due Date</TableHeading>
                                </TableCell10>
                                <TableCell12>
                                    <TableHeading>Responsible</TableHeading>
                                </TableCell12>
                                <TableCell16>
                                    <TableHeading>Resources</TableHeading>
                                </TableCell16>
                                <TableCell12>
                                    <TableHeading>Status</TableHeading>
                                </TableCell12>
                                <TableCell16>
                                    <TableHeading>Comments</TableHeading>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Stakeholder{"\n"}Communication</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>
                                        Strategies for{"\n"}engagement:{"\n"}{"\n"}
                                        &bull; Identify who key stakeholders are{"\n"}{"\n"}
                                        &bull; Create plan for{"\n"}engagement, that{"\n"}includes directors{"\n"}{"\n"}
                                        &bull; Measure{"\n"}engagement other than numbers of meetings or visits
                                    </TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s1q1.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Pdf: <Link style={styles.link} src="https://bit.ly/38axPbH">{"\n"}Stakeholder{"\n"}Communication Fact Sheet</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s1q1.color}`}}>
                                    <TableDataWhite>{ap.s1q1.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                            <TableRow>
                                <TableCell15>
                                    <TableData>Stakeholder{"\n"}Influence</TableData>
                                </TableCell15>
                                <TableCell19>
                                    <TableData>
                                        Complete the{"\n"}feedback loop:{"\n"}{"\n"}
                                        &bull; Identify key{"\n"}stakeholders to{"\n"}engage for{"\n"}feedback sessions for upcoming strategy formulation{"\n"}{"\n"}
                                        &bull; Create{"\n"}communication{"\n"}strategy for feedback to key stakeholders for how their{"\n"}information{"\n"}influences future planning and strategy
                                    </TableData>
                                </TableCell19>
                                <TableCell10>
                                    <TableData>{ap.s1q2.date}</TableData>
                                </TableCell10>
                                <TableCell12>
                                    <TableData>{this.props.rdata.form.firstname}{"\n"}{this.props.rdata.form.lastname}</TableData>
                                </TableCell12>
                                <TableCell16>
                                    <TableData>Video: <Link style={styles.link} src="https://bit.ly/3kI7c2C">{"\n"}Effective{"\n"}stakeholder{"\n"}engagement</Link></TableData>
                                </TableCell16>
                                <TableCell12 style={{backgroundColor: `${ap.s1q2.color}`}}>
                                    <TableDataWhite>{ap.s1q2.state}</TableDataWhite>
                                </TableCell12>
                                <TableCell16>
                                    <TableData></TableData>
                                </TableCell16>
                            </TableRow>
                        </Table>
                    </PageContent>
                    <Footer form={this.props.rdata.form} />
                </Page>
                <Page size="A4" style={styles.page}>
                    <Header/>
                    <PageContent>
                        <Heading>
                            About GovernWith
                        </Heading>
                        <About/>
                    </PageContent>
                    <Footer form={this.props.rdata.form} />
                </Page>
            </Document>
        )

    }
}

export default MyDocument;

const ProcessResults = (data, tdate) => {
    let response = {};
    let zeroDate = `${tdate.getDate()}/${tdate.getMonth()+1}/${tdate.getFullYear()}`;
    let newOneDate = new Date(tdate.setMonth(tdate.getMonth()+1));
    let oneDate = `${newOneDate.getDate()}/${newOneDate.getMonth()+1}/${newOneDate.getFullYear()}`
    let newTwoDate = new Date(tdate.setMonth(tdate.getMonth()+1));
    let twoDate = `${newTwoDate.getDate()}/${newTwoDate.getMonth()+1}/${newTwoDate.getFullYear()}`
    for (let [key, value] of Object.entries(data)) {
        switch (value) {
            case 'mature':
                response = {...response, [`${key}`]: {color: '#2f9900', state: 'Completed', date: zeroDate} };
                break;
            case 'developing':
                response = {...response, [`${key}`]: {color: '#fead04', state: 'Commenced', date: oneDate} };
                break;
            default:
                response = {...response, [`${key}`]: {color: '#fa0301', state: 'Not\nCommenced', date: twoDate} };
        }

    }
    return response;
}

// <Text style={styles.footertext} debug>Document prepared for</Text>
//
